import { Padrao } from '../generic/padrao';

export class SysTabela extends Padrao{

    override idTab = 76;

    nome: string;
    nomeObj: string;
    descricao: string;
    campoPadrao: number;
    criterioPadrao: string;
    instrucaoPesqRapida: string;
    cadastro: string;
    pesqAuto: string = 'NÃO';
    grupBy: string;
    sumario: string;
    ordem: string;
}